import routes from '@/modules/transaction/transaction-routes';
import store from '@/modules/transaction/transaction-store';

export default {
  routes,
  store,
};
